import { db, functions } from "../firebase";
import { EAudience, HelpArticle, HelpTopic, HELP_ARTICLE_FEEDBACK_FIELD, HELP_AUDIENCE_FIELD, WithID } from "../../types/db";
import { HTTP_ARTICLE_CONTENT_HELP } from "../../types/functions";
import { HelpService } from "../../types/services/help/HelpService";

const helpService = new HelpService(db);

export const getAudienceRootTopics = async (audience: EAudience, withCommon?: boolean): Promise<HelpTopic[]> => {
    return helpService
        .list((collection) => {
            var query = collection.where('type', '==', 'topic')//a topic
                .where('parent_id', '==', null);//at the root
            if (!!withCommon && audience !== EAudience.COMMON) {
                query = query.where(HELP_AUDIENCE_FIELD, 'in', [audience, EAudience.COMMON])
            } else {
                query = query.where(HELP_AUDIENCE_FIELD, '==', audience)
            }
            return query;
        }) as Promise<HelpTopic[]>
}

export const getTopicInfo = async (topicId: string) => {
    const data = await helpService.get(topicId);

    if (!data) {
        return Promise.reject("Topic not found");
    }
    if (data.type !== 'topic') {
        return Promise.reject("Not a topic");
    }

    return data as HelpTopic;
}

const getArticleBasicInfo = async (articleId: string) => {
    const data = await helpService.get(articleId);

    if (!data) {
        return Promise.reject("Article not found");
    }
    if (data.type !== 'article') {
        return Promise.reject("Not an article");
    }

    return data as HelpArticle;
}

/** Get the article content md only */
export const getArticleContent = async (articleID: string, locale: string) => {
    return functions.httpsCallable(HTTP_ARTICLE_CONTENT_HELP)({
        articleID,
        // articleID: '4ammSwaYp5ZtZVRGfImv',//this is the only one with markdown file data
        locale,
    })
        .then((res) => {
            return res.data as string;
        });
}

/** Get the help article information and content md */
export const getArticleInfo = async (articleId: string, locale?: string) => {
    const [article, content] = await Promise.all([
        getArticleBasicInfo(articleId),
        getArticleContent(articleId, locale || 'en')
    ]);

    return {
        ...article,
        content
    } as HelpArticle & { content: string };
}

export const getTopArticles = async (topicId?: string, limit?: number) => {
    //search for all articles
    return helpService.list((collection) => {
        var query = collection
            .where('type', '==', 'article')
            .orderBy(HELP_ARTICLE_FEEDBACK_FIELD, 'desc')
            .limit(limit || 6);
        if (!!topicId) {
            //search specifically under a certain topicId
            query = query.where('parent_id', '==', topicId)
        }
        return query;
    }) as Promise<WithID<HelpArticle>[]>;
}